/* eslint-disable react/no-array-index-key, consistent-return, @typescript-eslint/no-shadow, prettier/prettier, @typescript-eslint/no-unused-vars */
import { useState, useEffect, useCallback } from 'react';
import { IZkChangeLog } from '../../utils/types';
import useService from '../../utils/useService';

interface HistoryFilters {
	key: string;
	from: string;
	to: string;
}

const useHistory = () => {
	const [changes, setChanges] = useState<IZkChangeLog[]>([]);
	const [totalCount, setTotalCount] = useState(0);
	const [loading, setLoading] = useState(true);
	const [page, setPage] = useState(1);
	const [filters, setFilters] = useState<HistoryFilters>({
		key: '',
		from: '',
		to: ''
	});

	const { fetchHistory } = useService();
	const pageSize = 10;

	const loadHistory = useCallback(async () => {
		setLoading(true);
		try {
			const result = await fetchHistory({
				pageDetails: { pageNo: page, pageSize },
				key: filters.key || undefined,
				from: filters.from || undefined,
				to: filters.to || undefined
			});
			setChanges(result.data);
			setTotalCount(result.rowCount);
		} finally {
			setLoading(false);
		}
	}, [fetchHistory, page, filters]);

	useEffect(() => {
		loadHistory();
	}, [loadHistory]);

	const updateFilter = useCallback((field: keyof HistoryFilters, value: string) => {
		setFilters((prev) => ({ ...prev, [field]: value }));
		setPage(1);
	}, []);

	return {
		changes,
		totalCount,
		loading,
		page,
		setPage,
		pageSize,
		filters,
		updateFilter
	};
};

export default useHistory;
